import React, { Component } from 'react'
import { getInformationWithData } from '../../../services/CABE';
import "../../../css/inventory-style.css"
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import '../../../css/dashboard.css'
import { BsFileArrowUpFill, BsFileArrowDownFill, BsBoxSeam } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import LoadingWindow from '../../../components/LoadingWindow';
import { getIMGByItemCode, NumberFormat, OrderArray } from '../../../functions/generalFunctions';
import { pricesFormat } from '../../../functions/pricesFormat';
import { FormatQueryReturnDate, getDateFromReports, OrderArrayByDateGenericLinesDesc } from '../../../functions/dateFormat';
import { ItemXVendor, VendorXItem } from './Class'
import { getIndexElement } from '../../../functions/searchInObject';
import ModalOrders from '../../../components/ModalComponent';
import ExcelDocument from '../../../components/ExcelDocument';
import { getValueCookie } from '../../../services/cookieService';
import { getDataSet } from '../../../functions/generateDataSetExcel';
import { Menu } from "../../../components/Menu/Menu";

export default class PurchaseProcessReport extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        BodyFilter: [],
        flag: true,
        ItemVendorList: [],
        VendorItemList: [],
        AllInformation: [],
        mode: 'Item',
        ModalBody: [],
        ModalBodyFilter: [],
        showModal1: false,
        order: true,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            onHand:''
        }
    }

    async getVendors() {
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithData('/purchase/get/getItemsInPurchasesTravel',{IdCompany:Number(getValueCookie('CompanyId'))})
        let ItemVendorList = []
        let VendorItemList = []
        const data = {
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
            priceLevel: undefined,
            Component:null
        }
        const items=await getInformationWithData('/Items/get',data)

        if (result.status.code === 1) {
            for (const item of result.data) {
                const index = getIndexElement(ItemVendorList, 'ItemCode', item.ItemCode)
                const index2 = getIndexElement(VendorItemList, 'VendorNo', String(item.VendorNo))
                const index3 = getIndexElement(items.data,'itemCode', item.ItemCode)
                item.onHand=index3!==-1?items.data[index3].quantity:0
                let desc=''
                if(index3!==-1){
                    desc = (!(items.data[index3].completeDesc) || items.data[index3].completeDesc === "null") ? items.data[index3].abbreviatedDesc : items.data[index3].completeDesc
                        
                }
                if(desc){
                    item.abbreviatedDesc=desc
                }


                if (index === -1) {
                    let it = new ItemXVendor(item.ItemCode, item.abbreviatedDesc, null, null, null, null, null, null, null, null, null, null,item.onHand)
                    it.addVendor(new VendorXItem(String(item.VendorNo), item.VendorName, item.Carrier, item.Comment, item.OrderNo, item.OrderDate?FormatQueryReturnDate(item.OrderDate):null, item.completionDate?FormatQueryReturnDate(item.completionDate):null, item.QuantityOrdered, item.UnitCost, item.abbreviatedDesc, item.createBy))
                    ItemVendorList.push(it)
                } else {
                    ItemVendorList[index].addVendor(new VendorXItem(String(item.VendorNo), item.VendorName, item.Carrier, item.Comment, item.OrderNo, item.OrderDate?FormatQueryReturnDate(item.OrderDate):null, item.completionDate?FormatQueryReturnDate(item.completionDate):null, item.QuantityOrdered, item.UnitCost, item.abbreviatedDesc, item.createBy))
                    ItemVendorList[index].VendorList = OrderArrayByDateGenericLinesDesc(ItemVendorList[index].VendorList, 'OrderDate')
                }

                if (index2 === -1) {
                    let vend = new VendorXItem(String(item.VendorNo), item.VendorName, null, null, null, null, null, null, null, null, null)
                    vend.addItem(new ItemXVendor(item.ItemCode, item.abbreviatedDesc, null, item.Carrier, item.Comment, item.OrderNo, item.OrderDate?FormatQueryReturnDate(item.OrderDate):null,item.completionDate?FormatQueryReturnDate(item.completionDate):null, item.QuantityOrdered, item.UnitCost, item.abbreviatedDesc, item.createBy,item.onHand))
                    VendorItemList.push(vend)
                } else {
                    VendorItemList[index2].addItem(new ItemXVendor(item.ItemCode, item.abbreviatedDesc, null, item.Carrier, item.Comment, item.OrderNo, item.OrderDate?FormatQueryReturnDate(item.OrderDate):null, item.completionDate?FormatQueryReturnDate(item.completionDate):null, item.QuantityOrdered, item.UnitCost, item.abbreviatedDesc, item.createBy,item.onHand))
                    VendorItemList[index2].ItemList = OrderArrayByDateGenericLinesDesc(VendorItemList[index2].ItemList, 'OrderDate')
                }
            
                item.OrderDate=item.OrderDate?FormatQueryReturnDate(item.OrderDate):'Not Available' 
                item.completionDate=item.completionDate?FormatQueryReturnDate(item.completionDate):'Not Available'
                
            }
        }
        this.setState({ ItemVendorList: ItemVendorList, VendorItemList: VendorItemList, BodyFilter: ItemVendorList, mode: 'Item', AllInformation: result.data })
        this.ModalLoading.current.showState(false);

        document.getElementById("excelContainerPurchaseProcess").classList.remove("d-none");
        document.getElementById("loadDataContainerPurchaseProcess").classList.replace("col-12", "col-6");

    }

    valueRadioButton = async e => {
        let stat = e.target.value
        if (stat === 'Item') {
            this.setState({ BodyFilter: this.state.ItemVendorList, mode: stat })

        } else {

            this.setState({ BodyFilter: this.state.VendorItemList, mode: stat })
        }
    }

    async getVendorsList(index, it) {
        const temporal = this.state.currentItem
        temporal.ItemCode = it.ItemCode
        temporal.ItemCodeDesc = it.ItemCodeDesc
        temporal.ProductLine = it.ProductLineDesc
        temporal.itemURL = await getIMGByItemCode(it.ItemCode)
        temporal.onHand=it.onHand
        const index2=getIndexElement(this.state.ItemVendorList,'ItemCode',it.ItemCode)
        const item = this.state.ItemVendorList[index2]
        await this.setState({ ModalBody: item.VendorList, ModalBodyFilter: item.VendorList, currentItem: temporal })
        this.handleModalOpen("showModal1")

    }


    async getItemList(index, vend) {
        const index2=getIndexElement(this.state.VendorItemList,'VendorNo',vend.VendorNo)
        const vendor = this.state.VendorItemList[index2]
        
        const temporal = this.state.currentItem
        temporal.ItemCode = vend.VendorNo
        temporal.ItemCodeDesc = vend.VendorName

        await this.setState({ ModalBody: vendor.ItemList, ModalBodyFilter: vendor.ItemList, currentItem: temporal })
        this.handleModalOpen("showModal1")


    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    OrderInformation(array, key, state) {
        const order = OrderArray(array, key, this.state.order)
        this.setState({ [state]: order, order: !this.state.order })
    }
    contains(parametro, busqueda) {
       if(parametro){
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }
    }


    searchVendor = e => {

        let search = e.target.value;

        let Vendor=[]
        if (this.state.mode === 'Item') {
            Vendor = this.state.ItemVendorList.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ItemCodeDesc, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });

        } else {
            Vendor = this.state.VendorItemList.filter((vendor) => {
                if (((
                    this.contains(String(vendor.VendorNo), search) ||
                    this.contains(vendor.VendorName, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });

        }

        this.setState({ BodyFilter: Vendor });
    }



    searchVendorModal = e => {

        let search = e.target.value;

        let Vendor = []
        if (this.state.mode === 'Item') {
            Vendor = this.state.ModalBody.filter((vendor) => {
                if (((
                    this.contains(vendor.VendorNo, search) ||
                    this.contains(vendor.VendorName, search)||
                    this.contains(vendor.OrderBy, search)||
                    this.contains(vendor.OrderNo, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });

        } else {
            Vendor = this.state.ModalBody.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLineDesc, search) ||
                    this.contains(item.ItemCodeDesc, search)||
                    this.contains(item.OrderBy, search)||
                    this.contains(item.OrderNo, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
        }

        this.setState({ ModalBodyFilter: Vendor });
    }


    render() {
        const hasData = this.state.AllInformation.length !== 0
        const isItemMode = this.state.mode === 'Item'
        const pillLabelStyle = (active) => ({
            display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.35rem 0.9rem',
            borderRadius: '999px', fontSize: '0.8125rem', fontWeight: 700, cursor: 'pointer', userSelect: 'none',
            background: active ? 'rgba(255,255,255,0.25)' : 'transparent',
            color: active ? 'white' : 'rgba(255,255,255,0.55)'
        })

        return (
            // Old-shell pages (App.js) sit inside `.container-fluid.generalContainer`, which adds
            // Bootstrap's own left/right gutter (--bs-gutter-x: 1.5rem → 0.75rem/12px each side) plus
            // a 40px top padding — History KPI Inventory has neither (its own AppRouter route has no
            // ambient container). Left/right: negative margins cancel the known gutter exactly.
            // Top: `position:relative; top:-40px` (not a negative margin — margin-collapsing through
            // the parentless `.page` div made that unreliable) cancels the 40px ambient padding, then
            // History's own paddingTop (30px) is re-applied so the hero sits the same distance below
            // the topbar as it does on History's route.
            <div className='dash-page' style={{ marginLeft: '-0.75rem', marginRight: '-0.75rem', position: 'relative', top: '-40px', paddingTop: '30px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '3rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>In Transit Purchase Order Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData ? `${this.state.BodyFilter.length.toLocaleString('en-US')} ${isItemMode ? 'items' : 'vendors'} loaded` : 'Load data to view items and vendors in transit'}
                        </p>
                    </div>
                    <button id="loadDataContainerPurchaseProcess" onClick={() => this.getVendors()}
                        style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                        <AiOutlineReload /> Load Data
                    </button>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>
                {!hasData ? (
                    <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                        <BsBoxSeam style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                        <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Load Data</strong> to fetch the latest in-transit purchase order data.</p>
                    </div>
                ) : (
                /* Mode toggle + search + table */
                <div className='card' style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div style={{ display: 'inline-flex', background: 'rgba(255,255,255,0.08)', borderRadius: '999px', padding: '3px', gap: '2px' }}>
                            <label style={pillLabelStyle(isItemMode)}>
                                <input className="d-none" value={'Item'} onChange={this.valueRadioButton} checked={isItemMode} type="radio" name="typePurchaseReport" />
                                Item List
                            </label>
                            <label style={pillLabelStyle(!isItemMode)}>
                                <input className="d-none" value={'Vendor'} onChange={this.valueRadioButton} checked={!isItemMode} type="radio" name="typePurchaseReport" />
                                Vendor List
                            </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
                            <div id="excelContainerPurchaseProcess" className="d-none">
                                <ExcelDocument
                                    hidden={this.state.AllInformation.length === 0}
                                    archname={'Purchase Process ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                    sheetname={'Items Vendor Report ' + getValueCookie('Company')}
                                    data={getDataSet(this.state.ItemVendorList, ['Item Code', 'Description'], ['ItemCode', 'ItemCodeDesc'])}
                                    sheetname2={['Vendors List ' + getValueCookie('Company'), 'All Information Purchase Process Report ' + getValueCookie('Company')]}
                                    data2={[
                                        getDataSet(this.state.VendorItemList, ['Vendor No', 'Vendor Name'], ['VendorNo', 'VendorName']),
                                        getDataSet(this.state.AllInformation, ['Vendor No', 'Vendor Name', 'Item Code', 'Description', 'Order No','Order Date','Completion Date','Comment', 'Carrier','On Hand', 'Quantity Ordered','Unit Cost ($)','Ordered By'], ['VendorNo', 'VendorName', 'ItemCode', 'abbreviatedDesc', 'OrderNo','OrderDate','completionDate','Comment', 'Carrier','onHand','QuantityOrdered','UnitCost','createBy'])
                                    ]}
                                />
                            </div>
                            <div style={{ position: 'relative', minWidth: '220px', flex: '1 1 220px', maxWidth: '380px' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                <input type="text" autoComplete='off' id='searchPrincipalVendorPruchaseReport'
                                    placeholder={isItemMode ? 'Search Item by ItemCode, Line Product, Description...' : 'Search Vendor by VendorNo, Vendor Name...'}
                                    onChange={this.searchVendor}
                                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.4rem 0.75rem 0.4rem 2rem', width: '100%', outline: 'none' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='card-body p-0'>
                        {
                            this.state.mode === 'Item' ?

                                <div className='tableFixHead'>
                                    <table className='table align-middle table-hover mb-0'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCode', 'BodyFilter')} style={{ cursor: 'pointer', textAlign: 'center' }}>Item Code <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th hidden onClick={() => this.OrderInformation(this.state.BodyFilter, 'ProductLineDesc', 'BodyFilter')}>Product Line <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCodeDesc', 'BodyFilter')} style={{ cursor: 'pointer', textAlign: 'center' }}>Description <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.BodyFilter.map((item, i) => (
                                                    <tr onClick={() => this.getVendorsList(i, item)} key={i} style={{ cursor: 'pointer' }}>
                                                        <td className='text-center'>{item.ItemCode}</td>
                                                        <td hidden className='text-center'>{item.ProductLineDesc}</td>
                                                        <td className='text-center'>{item.ItemCodeDesc}</td>
                                                    </tr>
                                                ))

                                            }
                                        </tbody>

                                    </table>
                                </div>
                                :
                                <div className='tableFixHead'>
                                    <table className='table align-middle table-hover mb-0'>
                                        <thead className='table-dark'>
                                            <tr className='text-center'>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'VendorNo', 'BodyFilter')} style={{ cursor: 'pointer' }}>Vendor No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'VendorName', 'BodyFilter')} style={{ cursor: 'pointer' }}>Vendor Name <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.BodyFilter.map((vendor, v) => (
                                                    <tr onClick={() => this.getItemList(v, vendor)} key={v} style={{ cursor: 'pointer' }}>
                                                        <td className='text-center'>{(vendor.VendorNo)}</td>
                                                        <td className='text-start'>{vendor.VendorName}</td>
                                                    </tr>
                                                ))

                                            }
                                        </tbody>

                                    </table>
                                </div>
                        }
                    </div>
                </div>
                )}
                </div>

                <ModalOrders title={this.state.mode === 'Item' ? 'Vendors Detail' : 'Items Detail'} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    <div className='row'>
                        <div className='col-1 d-none d-md-block'></div>
                        {
                            this.state.mode === 'Item' ?
                                <div className='col-12 col-md-10'>
                                    <div className='row g-3 align-items-center'>
                                        <div className='col-12 col-md-6'>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Item Code</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginBottom: '12px', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCode}</div>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Description</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginBottom: '12px', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCodeDesc}</div>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Product Line</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginBottom: '12px', wordBreak: 'break-word' }}>{this.state.currentItem.ProductLine}</div>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>On Hand</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A' }}>{NumberFormat(this.state.currentItem.onHand)}</div>
                                        </div>
                                        <div className='col-12 col-md-6 text-center'>
                                            <div className='ItemImg' style={{ margin: '0 auto' }}>
                                                <img key={this.state.currentItem.itemURL} className='pb-5 pt-5' id='ShortsProductImg' src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'} alt='ProductImg' />
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-8 pt-2'>
                                            <div style={{ position: 'relative' }}>
                                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                                <input type="text" autoComplete='off' className="form-control" style={{ paddingLeft: '2.25rem', borderRadius: '8px' }} id='searchVendorPurchaseReportModal' placeholder={'Search Vendor by VendorNo, Vendor Name...'} onChange={this.searchVendorModal} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 pt-2 text-md-end">
                                            <ExcelDocument
                                                hidden={this.state.ModalBody.length === 0}
                                                archname={'Purchase Process Vendor List per Item ' + this.state.currentItem + " " + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Vendor List ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.ModalBody, ['Vendor No', 'Vendor Name', 'Order No','Order Date','Estimated Completion Date','Quantity Ordered','Unit Cost ($)','Ordered By'], ['VendorNo', 'VendorName', 'OrderNo','OrderDate','EstCompletionDate','QuantityOrdered','UnitCost','OrderBy'])}

                                            />
                                        </div>
                                        <div className='col-12 tableFixHead mt-2'>
                                            <table className='table align-middle table-hover mb-0'>
                                                <thead className='table-dark'>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorNo', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorName', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Vendor Name <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderNo', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Order No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Order Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'EstCompletionDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Estimated Completion Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'QuantityOrdered', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Quantity Ordered <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'UnitCost', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Unit Cost <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderBy', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Ordered By <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                    </tr>
                                                </thead>
                                                <tbody className='tbody'>
                                                    {
                                                        this.state.ModalBodyFilter.map((item, i) => (
                                                            <tr key={i}>
                                                                <td className='text-start'>{item.VendorNo}</td>
                                                                <td className='text-start'>{item.VendorName}</td>
                                                                <td className='text-center'>{item.OrderNo}</td>
                                                                <td className='text-center'>{item.OrderDate ? item.OrderDate : 'Not available'}</td>
                                                                <td className='text-center'>{item.EstCompletionDate?item.EstCompletionDate:'Not available'}</td>
                                                                <td className='text-center'>{item.QuantityOrdered?NumberFormat(item.QuantityOrdered):'0.00'}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{item.UnitCost ? pricesFormat( NumberFormat(item.UnitCost)) : '0.00'}</td>
                                                                <td className='text-center'>{item.OrderBy}</td>
                                                            </tr>
                                                        ))

                                                    }
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='col-12 col-md-10'>
                                    <div className='row g-3'>
                                        <div className='col-12'>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Vendor No</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', marginBottom: '12px', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCode}</div>
                                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Vendor Name</div>
                                            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A', wordBreak: 'break-word' }}>{this.state.currentItem.ItemCodeDesc}</div>
                                        </div>
                                        <div className='col-12 col-md-8'>
                                            <div style={{ position: 'relative' }}>
                                                <AiOutlineSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                                <input type="text" autoComplete='off' className="form-control" style={{ paddingLeft: '2.25rem', borderRadius: '8px' }} id='searchItemPurchaseReportModal' placeholder={'Search Item by ItemCode, Product Line, Description, Order No, Crated By...'} onChange={this.searchVendorModal} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 text-md-end">
                                            <ExcelDocument
                                                hidden={this.state.ModalBody.length === 0}
                                                archname={'Purchase Process Item List per Vendor ' + this.state.currentItem + " " + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Item List ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.ModalBody, ['Item Code', 'Description', 'Order No','Order Date','Estimated Completion Date','Quantity Ordered','On Hand','Unit Cost ($)','Ordered By'], ['ItemCode', 'Description', 'OrderNo','OrderDate','EstCompletionDate','QuantityOrdered','onHand','UnitCost','OrderBy'])}

                                            />
                                        </div>
                                        <div className='col-12 tableFixHead'>
                                            <table className='table align-middle table-hover mb-0'>
                                                <thead className='table-dark'>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCode', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Item Code <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th hidden onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ProductLineDesc', 'ModalBodyFilter')}>Product Line <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCodeDesc', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Description <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderNo', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Order No <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Order Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'EstCompletionDate', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Estimated Completion Date <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'QuantityOrdered', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Quantity Ordered <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'onHand', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>On Hand <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'UnitCost', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Unit Cost <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                        <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderBy', 'ModalBodyFilter')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Ordered By <BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {

                                                        this.state.ModalBodyFilter.map((item, i) => (
                                                            <tr key={i}>
                                                                <td className='text-start'>{item.ItemCode}</td>
                                                                <td hidden className='text-start'>{item.ProductLineDesc}</td>
                                                                <td className='text-start'>{item.Description}</td>
                                                                <td className='text-center'>{item.OrderNo}</td>
                                                                <td className='text-center'>{item.OrderDate ? item.OrderDate : 'Not available'}</td>
                                                                <td className='text-center'>{item.EstCompletionDate ?item.EstCompletionDate : 'Not available'}</td>
                                                                <td className='text-center'>{item.QuantityOrdered ? NumberFormat(item.QuantityOrdered) : '0.00'}</td>
                                                                <td className='text-center'>{item.onHand ? NumberFormat(item.onHand) : '0.00'}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{item.UnitCost ? pricesFormat(NumberFormat(item.UnitCost)) : '0.00'}</td>
                                                                <td className='text-center'>{item.OrderBy}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>

                                            </table>
                                        </div>
                                    </div></div>
                        }
                        <div className='col-1 d-none d-md-block'></div>
                    </div>
                </ModalOrders>

            </div>
        )
    }
}
